import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { PortalsActionCreators } from 'app/reducers/PortalsRedux'

import { monthToDateFromAndTo } from 'selectors/portals'

import CallsDetail from './CallsDetail'
import Charts from './Charts'
import { months } from './Charts/config'

import styles from './styles'

class Portals extends Component {
  constructor(props) {
    super(props)
    this.state = {
      preMonth: months[new Date().getMonth()]
    }
  }

  componentDidMount() {
    const params = monthToDateFromAndTo(new Date().getMonth())

    this.props.actions.getDataTableCalls(params.to, params.from)
    this.props.actions.getCallRecordsStats(params.to, params.from)
  }

  handleMonthChange = ({ month }) => {
    const { preMonth } = this.state

    if (month.value !== preMonth.value) {
      this.setState({ preMonth: month }, () => {
        const params = monthToDateFromAndTo(month.value)
        this.props.actions.getDataTableCalls(params.to, params.from)
        this.props.actions.getCallRecordsStats(params.to, params.from)
      })
    }
  }

  handleTablePageChange = (currentPage, perPage) => {
    const { generalParams } = this.props

    const offset = currentPage * perPage

    this.props.actions.getDataTableCalls(
      generalParams.to,
      generalParams.from,
      currentPage,
      offset
    )
  }

  render() {
    const {
      generalParams: { currentPage }
    } = this.props
    return (
      <div className="portals-container">
        <div className="portals-title">Resumen de llamadas</div>
        <Charts handleMonthChange={this.handleMonthChange} />
        <CallsDetail
          handleTablePageChange={this.handleTablePageChange}
          currentTablePage={currentPage}
        />
        <style jsx>{styles}</style>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  generalParams: state.portals.generalParams
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getDataTableCalls: PortalsActionCreators.getDataTableCalls,
      getCallRecordsStats: PortalsActionCreators.getCallRecordsStats
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(Portals)
